// contexts/NewProductContext.js
import React, { createContext, useState, useEffect, useContext } from "react";

const NewProductContext = createContext();

export const NewProductProvider = ({ children }) => {
  const [newProducts, setNewProducts] = useState([]);
  const [showNewProductNotification, setShowNewProductNotification] =
    useState(false);

  useEffect(() => {
    const checkNewProducts = async () => {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/api/products`
        );
        if (response.ok) {
          const data = await response.json();

          // Get the last check time from local storage
          const lastCheckedTime = localStorage.getItem("lastProductCheckTime");

          // Filter for truly new products
          const newlyAddedProducts = data.filter((product) => {
            // If no last check time, consider all products as not new
            if (!lastCheckedTime) return false;

            // Check if product is truly new
            return new Date(product.createdAt) > new Date(lastCheckedTime);
          });

          if (newlyAddedProducts.length > 0) {
            setNewProducts(newlyAddedProducts);
            setShowNewProductNotification(true);
          }
        }
      } catch (error) {
        console.error("Error checking new products:", error);
      }
    };

    // Check for new products immediately and then every hour
    checkNewProducts();
    const interval = setInterval(checkNewProducts, 3600000);

    return () => clearInterval(interval);
  }, []);

  const dismissNotification = () => {
    // Update the last check time to current moment
    localStorage.setItem("lastProductCheckTime", new Date().toISOString());
    setShowNewProductNotification(false);
  };

  return (
    <NewProductContext.Provider
      value={{
        newProducts,
        showNewProductNotification,
        dismissNotification,
      }}
    >
      {children}
      {showNewProductNotification && (
        <div className="new-product-notification">
          <div className="notification-content">
            {newProducts.length} New Product{newProducts.length > 1 ? "s" : ""}{" "}
            Added!
            <a href="/market" className="view-products-link">
              View in Market
            </a>
            <button
              onClick={dismissNotification}
              className="close-notification"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </NewProductContext.Provider>
  );
};

export const useNewProducts = () => useContext(NewProductContext);
